// BLOGS LISTING FUNCTIONALITIES

function initBlogSearch() {
  const form = document.querySelector('[data-blog-search-form]');
  const input = document.querySelector('[data-blog-search-input]');
  const searchBar = document.querySelector('[data-blog-search-bar]');
  const results = document.querySelector('[data-blog-search-results]');
  const openBtn = document.querySelector('[data-open-search]');
  const closeBtn = document.querySelector('[data-close-search]');

  if (!form || !input) return;

  const isBlogSource = form.querySelector('input[name="source"]')?.value === 'blog';
  const isInlineSearch = form.hasAttribute('data-inline-search');
  const predictiveSearchUrl = window.routes?.predictive_search_url;
  let abortController = new AbortController();
  const cachedResults = {};

  const currentQuery = new URLSearchParams(window.location.search).get('q')?.trim() || '';
  if (currentQuery && input.value.trim() !== currentQuery) input.value = currentQuery;

  const setInlineResultsOpen = (open) => {
    if (!results?.hasAttribute('data-inline-search-results')) return;
    const hasValue = Boolean(input.value.trim());
    const isFocused = document.activeElement === input || results.contains(document.activeElement);
    const shouldOpen = Boolean(open && hasValue && isFocused && results.innerHTML.trim());
    results.setAttribute('data-open', shouldOpen ? 'true' : 'false');
  };

  const goToSearch = (query) => {
    const url = new URL(form.action, window.location.origin);
    url.searchParams.set('q', query);
    if (isBlogSource) {
      url.searchParams.set('type', 'article');
      url.searchParams.set('source', 'blog');
    } else {
      url.searchParams.set('options[prefix]', 'last');
    }
    window.location.assign(`${url.pathname}${url.search}`);
  };

  const closeSearch = () => {
    searchBar?.setAttribute('data-blog-search-bar-open', 'false');
  };

  const openSearch = () => {
    if (!searchBar) return;
    searchBar.setAttribute('data-blog-search-bar-open', 'true');
    setTimeout(() => input.focus(), 300);
  };

  const clearResults = () => {
    if (results) results.innerHTML = '';
  };

  const renderResults = (markup) => {
    if (!results) return;
    results.innerHTML = markup;
    if (isInlineSearch) {
      setInlineResultsOpen(document.activeElement === input || results.contains(document.activeElement));
    }
  };

  const getSearchResults = (searchTerm) => {
    if (!predictiveSearchUrl || !results) return;

    const queryKey = `${isBlogSource ? 'blog' : 'all'}-${searchTerm.replace(/\s+/g, '-').toLowerCase()}`;
    if (cachedResults[queryKey]) {
      renderResults(cachedResults[queryKey]);
      return;
    }

    abortController.abort();
    abortController = new AbortController();

    const params = new URLSearchParams({
      q: searchTerm,
      section_id: 'enc-predictive-search',
      'resources[type]': isBlogSource
        ? 'query,collection,page,article'
        : 'query,product,collection,page,article',
      'resources[limit]': '5',
      'resources[limit_scope]': 'each',
    });
    if (isBlogSource) params.set('source', 'blog');

    fetch(`${predictiveSearchUrl}?${params.toString()}`, {
      signal: abortController.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const section = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-enc-predictive-search');
        const markup = section ? section.innerHTML : '';
        cachedResults[queryKey] = markup;
        renderResults(markup);
      })
      .catch((error) => {
        if (error?.name === 'AbortError' || error?.code === 20) return;
        clearResults();
      });
  };

  const onInput = debounce(() => {
    const searchTerm = input.value.trim();
    if (!searchTerm.length) {
      abortController.abort();
      abortController = new AbortController();
      clearResults();
      setInlineResultsOpen(false);
      return;
    }
    if (isInlineSearch && document.activeElement !== input) {
      setInlineResultsOpen(false);
      return;
    }
    getSearchResults(searchTerm);
  }, 300);

  let inlinePredictionsReady = !isInlineSearch;
  if (isInlineSearch) {
    window.setTimeout(() => {
      inlinePredictionsReady = true;
    }, 400);
  }
  openBtn?.addEventListener('click', (event) => {
    event.stopPropagation();
    openSearch();
  });
  closeBtn?.addEventListener('click', closeSearch);

  input.addEventListener('input', onInput);
  input.addEventListener('focus', () => {
    if (!isInlineSearch) return;
    if (!inlinePredictionsReady) {
      setInlineResultsOpen(false);
      return;
    }
    const searchTerm = input.value.trim();
    if (!searchTerm.length) {
      setInlineResultsOpen(false);
      return;
    }
    getSearchResults(searchTerm);
  });
  input.addEventListener('blur', () => {
    if (!isInlineSearch) return;
    setTimeout(() => {
      if (document.activeElement !== input && !results?.contains(document.activeElement)) {
        setInlineResultsOpen(false);
      }
    }, 150);
  });
  setInlineResultsOpen(false);
  if (!isInlineSearch && currentQuery) getSearchResults(currentQuery);

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const searchTerm = input.value.trim();
    if (!searchTerm.length) return;
    goToSearch(searchTerm);
  });

  results?.addEventListener('click', (event) => {
    const submitLink = event.target.closest('[data-blog-search-submit]');
    if (!submitLink) return;
    event.preventDefault();
    const searchTerm = input.value.trim();
    if (!searchTerm.length) return;
    goToSearch(searchTerm);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  document.addEventListener('click', (e) => {
    if (!searchBar) return;
    const target = e.target;
    if (
      searchBar.getAttribute('data-blog-search-bar-open') === 'true' &&
      !searchBar.contains(target) &&
      target !== openBtn &&
      !openBtn?.contains(target)
    ) {
      closeSearch();
    }
  });
}

function initProductBlogSwiper() {
  if (!document.querySelector('.blog-product-swiper') || typeof Swiper === 'undefined') return;
  new Swiper('.blog-product-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: true,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBlogSearch();
  initProductBlogSwiper();
});
